<template>
  <div>
    <el-button
      :class="[store.config.proceed_classes || 'wpcm-proceed-btn']"
      @click="submit()"
      v-if="store.step === store.config.steps"
      >{{ store.config.donate_now }}</el-button
    >
  </div>
</template>

<script setup lang="ts">
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';
import descriptor from '../utils/rules'

const store = useDonationFormsStore();
const _ = globalThis._;

const submit = () => {
  const { $state } = store;
    store.validate({ rules: descriptor, fields: $state })
    .then((res) => {
      store.submit()
    })
    .catch(({fields, errors}) => {
      validation_catch(fields, errors);
    });
};
const validation_catch = (fields, errors) => {
  _.each(fields, (field) => {
    setTimeout(() => {
      ElNotification({
        type: 'error',
        title: "Error",
        message: field[0].message,
        offset: 40,
      });
    }, 300);
  });
};


</script>